import { Component, OnInit } from '@angular/core';
import { NextstepsService } from './nextsteps.service';
import { Observable } from 'rxjs/Observable';
import { Store } from '@ngrx/store';
import { AppState } from 'src/store/reducers';
import { environment } from 'src/environments/environment';
import { CommonService } from '../../../app/core/services/common/common.service';
import { Subscription } from 'rxjs/Subscription';
import { NgxSpinnerService } from 'ngx-spinner';
import { userState, selectuserState, selectAuthState } from 'src/store/reducers';
import { toastmessagesService } from "../../core/services/messages/toastmessages.service";
import { nextStep } from '../../core/interfaces/user';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-nextsteps',
  templateUrl: './nextsteps.component.html',
  styleUrls: ['./nextsteps.component.scss']
})
export class NextstepsComponent implements OnInit,nextStep {
  getState: Observable<any>;
  tupasVerified = false;
  userState: Observable<any>;
  email_verified = false;
  is_ind_org : boolean = true;
  tupasKey: Boolean = true;
  verifyEmailKey: Boolean = false;
  providerKey: Boolean = false;
  tupasSubscription;
  errorMessage;
  userType;
  constructor(private nextStep: NextstepsService, 
    private store: Store<userState>, 
    private appstore: Store<AppState>,
    private spinner: NgxSpinnerService,
    private message: toastmessagesService,
    private route: ActivatedRoute,
    private commonService: CommonService
    ) {

    this.userState = this.store.select(selectuserState);
    this.getState = this.store.select(selectAuthState);
    

  }

  ngOnInit() {
    // this.setTupas();
    this.getQueryParams();
    this.nextStep.dispatchUserAction();
    this.callUserState();
    this.tupasSubscription = this.getState.subscribe((state) => {
      if(state.action === 'tupas')
      {
        this.errorMessage = state.errorMessage;
        this.showMessage(state);
      }
      
      });
      
  }

  tupasLogin() {
    let payload = this.retrievePayload();
    
    this.nextStep.dispatchTupasAction(payload);
    this.spinner.show();
  }

  emailVerified(){
    this.nextStep.dispatchUserEmailVerifiedAction();
    this.nextStep.dispatchUserAction();
  }

  retrievePayload()
  {
    return {
      "url": environment.WEB_URL + `en/dashboard/view-links`,
      "action": "connect",
      "account_from": 'liiteri',
    }
  }

  setUserState(state)
  {
    if(state.userById){
      this.userType = state.userById.user_type;
      console.log(this.userType,"user type");
      let { tupas_verified, email_verified } = state.userById.properties;
      this.email_verified = email_verified;
      this.tupasVerified  =  tupas_verified;
      if(tupas_verified && !email_verified)
      {
       this.tupasKey = false;
       this.verifyEmailKey = true;
      }
      if(email_verified && tupas_verified)
      {
        this.tupasKey = false;
        this.verifyEmailKey = false;
        this.providerKey = true;
      }
      
     
    }
  }

  setTupas()
  {
    this.getState.subscribe((state) => {
      this.tupasVerified = state.tupasVerified;
    });
  }
  callUserState()
  {
    this.userState.subscribe((state) => {
      this.setUserState(state);
    });
  }

  changeIndOrgTabs()
  {
    this.is_ind_org = !this.is_ind_org;
  }

  next(key)
  {
    if(key === 'verify')
    {
      this.tupasKey = false;
      this.verifyEmailKey = true;
    }
    else if(key === 'indOrg')
    {
      this.tupasKey = false;
      this.verifyEmailKey = false;
      this.providerKey = true;
      /* if(this.providerKey && this.userType == 'buyer'){
        
      } */
    }
  }
  showMessage(state) {
    if (state.success)
    {
      this.spinner.hide();
      window.location.href = state.url
    }
    else if(!state.success && state.success !== null && state.success !== undefined)
    {
      this.sucesserrorMsg('errorToastr', state.errorMessage);
      this.spinner.hide();
    }
  }
  sucesserrorMsg(status, message)
  {
    this.message.messageHandler(status, message);
  }

  getQueryParams() {
    let query = this.route.queryParams['_value'].message;
    console.log(query,"query");
    this.route.queryParams.subscribe(params => {
      console.log(params,"params")
      const param = params['message'];
      const sucess = params['success'] 
      
      if(sucess == 'true'){
        this.commonService.getTranslationResponse('successToastr',param)
      }
      if(sucess == 'false'){
        this.commonService.getTranslationResponse('errorToastr',param)  
      }
    });
  }
}
